import { byAttrVal, createCustomElement, DOMModel } from '@adobe/react-webcomponent'
import { Icon, IconName, IconSize } from '@billy/design-system'
import { ColorOrCurrent } from '@billy/design-system/src/types/colorOrCurrent'
import { ReactElement } from 'react'

class LucideIconWebComponent extends DOMModel {
  @byAttrVal('icon') icon: string
  @byAttrVal size: string
  @byAttrVal color: string
}

interface LucideIconProps {
  icon: IconName
  size?: IconSize
  color?: ColorOrCurrent
}

const LucideIconModule = ({ icon, size = 'sm', color }: LucideIconProps): ReactElement => {
  return <Icon icon={icon} size={size} color={color} id={icon as string} />
}

const LucideIconCustomElement = createCustomElement(LucideIconModule, LucideIconWebComponent, 'element')

customElements.get('lucide-icon-module') || customElements.define('lucide-icon-module', LucideIconCustomElement)

export default LucideIconCustomElement
